// extracted by mini-css-extract-plugin
export var catalog = "catalog-module--catalog--ovvf0";
export var content = "catalog-module--content--udy5x";
export var descriptionBox = "catalog-module--description-box--xW-C6";
export var layout = "catalog-module--layout--Irv7h";
export var listGrid = "catalog-module--list-grid--8ichG";
export var title = "catalog-module--title--OzikQ";